import { useMemo } from "react";
import { useAuth } from "../AuthContext";
import { resolveUseMetricUnits, unitsFor, makeFormatters } from "../units";

// Read from the cached sign-in payload, never a query: the unit feeds GraphQL
// variables so it must be known synchronously, before the first speed query fires.
const useUnits = () => {
  const { user, account } = useAuth() || {};

  const useMetricUnits = resolveUseMetricUnits(
    user?.useMetricUnits,
    account?.tenant?.useMetricUnits,
  );

  return useMemo(() => {
    const { speedUnit, distanceUnit } = unitsFor(useMetricUnits);
    const formatters = makeFormatters(useMetricUnits, navigator.language);

    return { useMetricUnits, speedUnit, distanceUnit, ...formatters };
  }, [useMetricUnits]);
};

export default useUnits;
